module.exports = __webpack_public_path__ + "img/Desctope-screen.e4e4103a.jpg";